/**
 * Capitalizes the first letter of a given string.
 * @param string - The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalize = (string: string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
